import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/@babel/runtime/regenerator/index.js";
import { Button, Card, Dropdown, Input, Space, Tooltip } from 'antd';
import { DownOutlined, ShareAltOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import Auth from '@aws-amplify/auth';
import handleError from 'utils/http/handleError';
import validateInput, { rules } from 'utils/validateInputs';
import endUserMessages from 'utils/endUserMessages';
import pushNotificationMessage from 'utils/pushNotificationMessage';
var TextArea = Input.TextArea;
var initialMessage = 'Hi,\n\nCheck out Cellenics. It will make your single-cell analysis easier.';
var ReferralButton = function ReferralButton() {
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useState2 = useState(''),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(false),
    isEmailValid = _useState3[0],
    setIsEmailValid = _useState3[1];
  var _useState4 = useState(initialMessage),
    customMessage = _useState4[0],
    setCustomMessage = _useState4[1];
  var submitReferral = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var user, userContext, referralData, _yield$import, getReferralWebhookUrl, r;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setVisible(false);
            _context.prev = 1;
            _context.next = 4;
            return Auth.currentAuthenticatedUser();
          case 4:
            user = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            console.warn('User not authenticated');
          case 10:
            userContext = user ? [{
              type: 'mrkdwn',
              text: '*From:*'
            }, {
              type: 'mrkdwn',
              text: user.attributes.name
            }, {
              type: 'mrkdwn',
              text: '*Email:*'
            }, {
              type: 'plain_text',
              text: user.attributes.email
            }, {
              type: 'mrkdwn',
              text: '*Domain:*'
            }, {
              type: 'plain_text',
              text: window.location.hostname
            }, {
              type: 'mrkdwn',
              text: '*User UUID:*'
            }, {
              type: 'plain_text',
              text: user.username
            }] : [];
            referralData = {
              blocks: [{
                type: 'section',
                text: {
                  type: 'plain_text',
                  text: "To: ".concat(email)
                }
              }, {
                type: 'section',
                text: {
                  type: 'plain_text',
                  text: "Message:\n ".concat(customMessage)
                }
              }, {
                type: 'divider'
              }, {
                type: 'context',
                elements: [].concat(userContext)
              }]
            };
            _context.prev = 12;
            _context.next = 15;
            return import('utils/slack');
          case 15:
            _yield$import = _context.sent;
            getReferralWebhookUrl = _yield$import.getReferralWebhookUrl;
            _context.next = 19;
            return fetch(getReferralWebhookUrl(), {
              method: 'POST',
              body: JSON.stringify(referralData)
            });
          case 19:
            r = _context.sent;
            if (r.ok) {
              _context.next = 22;
              break;
            }
            throw new Error('Invalid status code returned.');
          case 22:
            setEmail('');
            setCustomMessage(initialMessage);
            pushNotificationMessage('success', endUserMessages.REFERRAL_SUCCESSFUL);
            _context.next = 30;
            break;
          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](12);
            handleError(_context.t1, endUserMessages.REFERRAL_ERROR);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7], [12, 27]]);
    }));
    return function submitReferral() {
      return _ref.apply(this, arguments);
    };
  }();
  var menuItems = [{
    label: /*#__PURE__*/React.createElement(Card, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Space, {
      direction: "vertical",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Input, {
      addonBefore: "To: ",
      label: "Email",
      onChange: function onChange(e) {
        var _validateInput = validateInput(e.target.value, rules.VALID_EMAIL),
          isValid = _validateInput.isValid;
        setIsEmailValid(isValid);
        setEmail(e.target.value);
      },
      placeholder: 'Your friend\'s email address'
    }), /*#__PURE__*/React.createElement(TextArea, {
      value: customMessage,
      label: "Custom message",
      onChange: function onChange(e) {
        setCustomMessage(e.target.value);
      },
      rows: 4,
      style: {
        resize: 'none',
        width: 300,
        outline: 'none'
      }
    }), /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      onClick: function onClick() {
        return setVisible(false);
      }
    }, "Cancel"), /*#__PURE__*/React.createElement(Tooltip, {
      title: !isEmailValid ? 'Please enter a valid email address' : ''
    }, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      type: "primary",
      disabled: !isEmailValid,
      onClick: submitReferral
    }, "Send invite"))))),
    key: 'referral-button-contents'
  }];
  return /*#__PURE__*/React.createElement(Dropdown, {
    open: visible,
    onOpenChange: function onOpenChange(v) {
      return setVisible(v);
    },
    menu: {
      items: menuItems
    },
    placement: "bottomRight",
    trigger: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "dashed",
    icon: /*#__PURE__*/React.createElement(ShareAltOutlined, null)
  }, "Invite a friend", /*#__PURE__*/React.createElement(DownOutlined, null)));
};
export default ReferralButton;